import {
  IonAvatar,
  IonButton,
  IonCol,
  IonGrid,
  IonIcon,
  IonItem,
  IonLabel,
  IonRow,
} from "@ionic/react";
import dayjs from "dayjs";
import "dayjs/locale/es";
import axios from "axios";
import {
  calendar,
  calendarOutline,
  chevronForward,
  chevronForwardOutline,
  close,
  closeOutline,
  fileTrayFull,
  fileTrayFullOutline,
  flask,
  flaskOutline,
  peopleCircle,
  peopleCircleOutline,
  print,
  printOutline,
} from "ionicons/icons";
import React, { useEffect, useState } from "react";
import { useHistory } from "react-router";
import { DialogoConfirmacion } from "../../components/basicsComponents/DialogoConfirmacion/DialogoConfirmacion";
import {
  convertToPlain,
  obtenerNombreDia,
} from "../../utils/funcionalidadesStrings";
import {
  Column,
  Row,
} from "../../components/basicsComponents/MaterialGridComponents";
import {
  Accordion,
  AccordionDetails,
  AccordionGroup,
  AccordionSummary,
  Button,
  Card,
  Typography,
} from "@mui/joy";
import ComprobanteTurno from "../../components/formComponents/ComprobanteTurno/ComprobanteTurno";
import CustomToast from "../../components/basicsComponents/CustomToast/CustomToast";
import { LibraryAdd, Person, PrecisionManufacturing } from "@mui/icons-material";
import useTituloPagina from "../../hooks/tituloPagina";
import { esTelemedicina } from "../../utils/turnos";
import LoadingBackdrop from "../../components/basicsComponents/LoadingBackdrop/LoadingBackdrop";
import "./MainPage.css";

const LABORATORIO_URL = "https://cloudlablace.com.ar/#/login";
const MOSTRAR_FOTOS_PRESTADORES_RECIENTES = true;

const obtenerCampo = (objeto = {}, ...campos) => {
  const campoEncontrado = campos.find(
    (campo) => objeto?.[campo] !== undefined && objeto?.[campo] !== null,
  );

  return campoEncontrado ? objeto[campoEncontrado] : undefined;
};

const inferirMimeTypeImagenBase64 = (imagenBase64 = "") => {
  if (typeof imagenBase64 !== "string") {
    return "image/jpeg";
  }

  const imagenNormalizada = imagenBase64.trim();

  if (imagenNormalizada.startsWith("/9j/")) {
    return "image/jpeg";
  }

  if (imagenNormalizada.startsWith("iVBORw0KGgo")) {
    return "image/png";
  }

  if (imagenNormalizada.startsWith("Qk")) {
    return "image/bmp";
  }

  if (imagenNormalizada.startsWith("UklGR")) {
    return "image/webp";
  }

  return "image/jpeg";
};

const obtenerFotoPrestador = (prestador = {}) => {
  const foto = obtenerCampo(
    prestador,
    "foto",
    "Foto",
    "fotoWeb",
    "FotoWeb",
    "imagen",
    "Imagen",
    "imagenWeb",
    "ImagenWeb",
    "fotoBase64",
    "FotoBase64",
    "imagenBase64",
    "ImagenBase64",
  );

  if (typeof foto !== "string" || foto.trim() === "") {
    return "";
  }

  const fotoNormalizada = foto.trim();
  if (
    fotoNormalizada.startsWith("data:") ||
    fotoNormalizada.startsWith("http://") ||
    fotoNormalizada.startsWith("https://")
  ) {
    return fotoNormalizada;
  }

  const mimeType = inferirMimeTypeImagenBase64(fotoNormalizada);
  return `data:${mimeType};base64,${fotoNormalizada}`;
};

const MainPage = (props) => {
  const [cargandoAccion, setCargandoAccion] = useState(false);
  const [paciente, setPaciente] = useState({});

  const [turnoSeleccionado, setTurnoSeleccionado] = useState({});
  const [abrirModalCancelarReserva, setAbrirModalCancelarReserva] =
    useState(false);
  const [abrirComprobanteTurno, setAbrirComprobanteTurno] = useState(false);

  const [listadoTurnos, setListadoTurnos] = useState([]);
  const [prestadores, setPrestadores] = useState([]);
  const [prestadoresRecientes, setPrestadoresRecientes] = useState([]);
  const [estudios, setEstudios] = useState([]);
  const [servicios, setServicios] = useState([]);
  const [toast, setToast] = useState({ open: false, mensaje: "", tipo: "" });
  const mostrarNotificacion = (abrir, mensaje, tipo) => {
    let notificacion = {};
    if (abrir) {
      notificacion = { open: true, mensaje: mensaje, tipo: tipo };
    } else {
      notificacion = { open: false, mensaje: "", tipo: "" };
    }
    setToast(notificacion);
  };
  const history = useHistory();
  useTituloPagina();

  const traerPrestadores = async (paciente) => {
    try {
      const url = localStorage.getItem("urlAxioPP");
      const config = {
        headers: { Authorization: `Bearer ${paciente.token}` },
      };

      const response = await axios.get(`${url}Prestadores`, config);
      if (response.data.length !== 0) {
        setPrestadores(response.data);
      }
    } catch (e) {
      mostrarNotificacion(true, "Error al cargar prestadores", "rojo");
    }
  };

  const traerTurnosPaciente = async (paciente) => {
    let turnosFuturos = null;
    let tmpPrestadoresRecientes = null;
    const url = localStorage.getItem("urlAxioPP");
    const config = {
      headers: { Authorization: `Bearer ${paciente.token}` },
    };

    try {
      const servicio = await axios
        .get(`${url}Servicios`, config)
        .then((response) => {
          if (response.data.length !== 0) {
            return response.data;
          } else {
            return null;
          }
        });
      if (servicio !== null) {
        const response = await axios.get(
          `${url}Turnos/TurnosPaciente/?paciente=${paciente.codigo}&servicio=${servicio[0].codigo}`,
          config,
        );
        if (response.data.length !== 0) {
          turnosFuturos = response.data;
          tmpPrestadoresRecientes = response.data;

          turnosFuturos = turnosFuturos.filter((turno) => {
            return dayjs(new dayjs()).isBefore(dayjs(turno.fecha));
          });
          turnosFuturos = turnosFuturos.sort((a, b) => {
            const fechaA = dayjs(a.fecha);
            const fechaB = dayjs(b.fecha);

            if (fechaA.isBefore(fechaB)) {
              return -1;
            } else if (fechaA.isAfter(fechaB)) {
              return 1;
            } else {
              const horaA = dayjs(a.hora, "HH:mm:ss");
              const horaB = dayjs(b.hora, "HH:mm:ss");

              if (horaA.isBefore(horaB)) {
                return -1;
              } else if (horaA.isAfter(horaB)) {
                return 1;
              } else {
                return 0;
              }
            }
          });
          turnosFuturos = turnosFuturos.slice(0, 5);

          tmpPrestadoresRecientes = tmpPrestadoresRecientes
            .sort((a, b) => dayjs(b.fecha).diff(dayjs(a.fecha))) // Orden cronológico inverso
            .filter(
              (value, index, self) =>
                index ===
                self.findIndex(
                  (t) =>
                    t.prestadorCod === value.prestadorCod &&
                    t.prestadorNom === value.prestadorNom,
                ),
            )
            .slice(0, 4)
            .map((turno) => {
              return {
                prestadorCod: turno.prestadorCod,
                prestadorNom: turno.prestadorNom,
                especialidadNom: turno.especialidadNom,
              };
            })
            .sort((a, b) => a.prestadorNom.localeCompare(b.prestadorNom));
        } else {
          turnosFuturos = [];
          tmpPrestadoresRecientes = [];
        }
        setListadoTurnos(turnosFuturos);
        setPrestadoresRecientes(tmpPrestadoresRecientes);
      }
    } catch (e) {
      mostrarNotificacion(
        true,
        "Ocurrió un problema al intentar consultar sus Próximos turnos",
        "rojo",
      );
    }
  };

  const traerEstudios = async (paciente) => {
    let estudios = [];
    const url = localStorage.getItem("urlAxioPP");
    const config = {
      headers: { Authorization: `Bearer ${paciente.token}` },
    };

    try {
      const response = await axios.get(`${url}Estudios`, config);
      if (response.data.length !== 0) {
        estudios = response.data;
      }

      estudios = estudios.map((estudio) => {
        return {
          ...estudio,
          text: estudio.nombre,
        };
      });

      setEstudios(estudios);
    } catch (e) {
      mostrarNotificacion(
        true,
        "Se produjo un error al consultar l registradas en el sistema",
        "rojo",
      );
    }
  };

  const TraerServicio = async (paciente) => {
    try {
      let servicioResponse = {};
      const url = localStorage.getItem("urlAxioPP");
      const config = {
        headers: { Authorization: `Bearer ${paciente.token}` },
      };
      servicioResponse = await axios
        .get(`${url}Servicios`, config)
        .then((response) => {
          if (response.data.length !== 0) {
            return response.data;
          }
        });
      setServicios(servicioResponse);
    } catch (e) {}
  };
  const CancelarTurno = async () => {
    try {
      const urlAxioPP = localStorage.getItem("urlAxioPP");
      const config = {
        headers: { Authorization: `Bearer ${paciente.token}` },
      };

      let servicio = null;
      const serviciosResponse = await axios.get(
        `${urlAxioPP}Servicios`,
        config,
      );

      if (serviciosResponse.data.length !== 0) {
        servicio = serviciosResponse.data[0];
      }

      if (servicio?.codigo !== null && turnoSeleccionado) {
        const cancelarTurnoResponse = await axios
          .patch(
            `${urlAxioPP}Turnos/Cancelar/${turnoSeleccionado.codigo}`,
            "",
            config,
          )
          .then(
            async () =>
              await axios.patch(
                `${urlAxioPP}Turnos/Quitar/${turnoSeleccionado.codigo}`,
                "",
                config,
              ),
          );

        if (
          cancelarTurnoResponse.status === 200 &&
          cancelarTurnoResponse.statusText === "OK"
        ) {
          mostrarNotificacion(
            true,
            "El turno se cancelo correctamente",
            "verde",
          );
        } else {
          mostrarNotificacion(
            true,
            "Ocurrió un problema al intentar cancelar el turno",
            "rojo",
          );
        }
      }
    } catch ({ response }) {
      mostrarNotificacion(true, "Error: " + response.data, "rojo");
    }
  };

  useEffect(() => {
    let activo = true;

    const inicializarHome = async () => {
      try {
        const sesion = JSON.parse(sessionStorage.getItem("ppUL"));
        if (!sesion) {
          return;
        }

        if (activo) {
          setPaciente(sesion);
          document.title = localStorage.getItem("tituloWeb");
        }

        await Promise.all([
          traerTurnosPaciente(sesion),
          traerEstudios(sesion),
          TraerServicio(sesion),
          traerPrestadores(sesion),
        ]);
      } catch (e) {
        if (activo) {
          history.push({ pathname: "/ErrorPage" });
        }
      }
    };

    inicializarHome();

    return () => {
      activo = false;
    };
  }, [history]);

  const handleClickRedirigir = (destino) => {
    if (destino === "Laboratorio") {
      window.open(LABORATORIO_URL, "_blank", "noopener,noreferrer");
      return;
    }

    const rutasPortal = {
      "Reservar turno": "/portal/Reservar turno",
      "Reservar turno estudios": "/portal/Reservar turno estudios",
      Turnos: "/portal/Turnos",
      Estudios: "/portal/Estudios",
      Horarios: "/portal/Horarios",
    };

    const rutaDestino = rutasPortal[destino];
    if (rutaDestino) {
      history.push(rutaDestino);
      return;
    }

    mostrarNotificacion(true, "Seleccion invalida", "rojo");
  };

  const togleAbrirCerrarCancelarReserva = () => {
    if (abrirModalCancelarReserva) {
      setTurnoSeleccionado({});
    }
    setAbrirModalCancelarReserva(!abrirModalCancelarReserva);
  };

  const handleClickSeleccionarTurno = (turno) => {
    setTurnoSeleccionado(turno);
    togleAbrirCerrarCancelarReserva();
  };

  const handleClickCancelarReserva = async () => {
    togleAbrirCerrarCancelarReserva();
    setCargandoAccion(true);
    await CancelarTurno();
    await traerTurnosPaciente(paciente);
    setCargandoAccion(false);
  };

  const handleClickComprobanteTurno = (turno) => {
    const prestadorEncontrado = prestadores.find(
      (prestador) => turno.prestadorCod === prestador.codigo,
    );
    const servicioEncontrado = servicios.find(
      (servicio) => servicio.codigo === 1,
    );
    const lugarAtencion =
      (prestadorEncontrado ? prestadorEncontrado.domicilioTurno : null) ||
      (servicioEncontrado ? servicioEncontrado.direccion : "") ||
      "";

    setTurnoSeleccionado({
      codigo: turno.codigo,
      equipoNom: turno.equipoNom,
      especialidadNom: turno.especialidadNom,
      estudioNom: turno.estudioNom,
      fecha: turno.fecha,
      hora: turno.hora,
      mutualNom: turno.mutualNom,
      prestadorNom: turno.prestadorNom,
      servicio: turno.servicio,
      apellido: paciente.apellido,
      nombre: paciente.nombre,
      mutualNombre: paciente.mutualNombre,
      mutualAfiliado: paciente.mutualAfiliado,
      hc: paciente.hc,
      documentoTipoNombre: paciente.documentoTipoNombre,
      documentoNro: paciente.documentoNro,
      celular: paciente.celular,
      email: paciente.email,
      lugarAtencion: lugarAtencion,
      telemedicina: esTelemedicina(turno.telemedicina),
      preparacionEstudio: null,
    });
    setAbrirComprobanteTurno(true);
  };

  const togleAbrirCerrarComprobanteTurno = () => {
    if (abrirComprobanteTurno) {
      setTurnoSeleccionado({});
    }
    setAbrirComprobanteTurno(!abrirComprobanteTurno);
  };

  const handleClickReservarTurnoPrestador = async (prestadorCod) => {
    setCargandoAccion(true);

    try {
      const url = localStorage.getItem("urlAxioPP");
      const config = {
        headers: { Authorization: `Bearer ${paciente.token}` },
      };

      const response = await axios.get(
        `${url}Prestadores?mutuales=${paciente.mutual}`,
        config,
      );

      if (response.data.length !== 0) {
        let prestadores = response.data;

        prestadores = prestadores.filter(
          (prestador) => prestador.vigente === true,
        );

        let edad = dayjs(dayjs()).diff(paciente.nacimiento, "year");

        prestadores = prestadores.filter((prestador) => {
          if (prestador.filtroEdad) {
            return prestador.edadDesde <= edad && edad <= prestador.edadHasta;
          } else {
            return true;
          }
        });

        if (edad <= 15) {
          prestadores = prestadores.filter((prestador) =>
            [125, 115].includes(prestador.especialidad),
          );
        } else {
          prestadores = prestadores.filter(
            (prestador) => ![125, 115].includes(prestador.especialidad),
          );
        }

        const prestadorEncontrado = prestadores.find(
          (prestador) => prestador.codigo === prestadorCod,
        );

        if (prestadorEncontrado) {
          history.push({
            pathname: "/portal/Reservar turno",
            state: { prestador: prestadorCod },
          });
        } else {
          mostrarNotificacion(
            true,
            "El prestador ya no está disponible, se redirige a seleccionar una Especialidad",
            "amarillo",
          );

          setTimeout(() => {
            history.push({
              pathname: "/portal/Reservar turno",
            });
          }, 2000);
        }
      } else {
        mostrarNotificacion(
          true,
          "No hay prestadores disponibles en este momento",
          "amarillo",
        );

        setTimeout(() => {
          history.push({
            pathname: "/portal/Reservar turno",
          });
        }, 2000);
      }
    } catch (e) {
      mostrarNotificacion(
        true,
        "Error al verificar la disponibilidad del prestador, se redirige a seleccionar una Especialidad",
        "rojo",
      );

      setTimeout(() => {
        history.push({
          pathname: "/portal/Reservar turno",
        });
      }, 2000);
    } finally {
      setCargandoAccion(false);
    }
  };

  const obtenerVisualPrestadorReciente = (fila) => {
    const esEquipo =
      !fila?.prestadorCod ||
      String(fila?.prestadorNom || "")
        .trim()
        .toUpperCase() === "EQUIPOS";

    if (esEquipo) {
      return {
        tipo: "equipo",
        descripcion: "Equipo",
        imageSrc: "",
      };
    }

    const prestadorEncontrado = prestadores.find(
      (prestador) => Number(prestador.codigo) === Number(fila.prestadorCod),
    );

    const imageSrc = MOSTRAR_FOTOS_PRESTADORES_RECIENTES
      ? obtenerFotoPrestador(prestadorEncontrado)
      : "";

    return {
      tipo: imageSrc ? "foto" : "persona",
      descripcion: fila?.prestadorNom || "Prestador",
      imageSrc,
    };
  };

  const renderPrestadoresRecientes = (seePreviusVersion) => {
    return (
      <Row
        style={{ textAlign: "start" }}
        alignItems="stretch"
        container
        spacing={2}
      >
        {prestadoresRecientes.map((fila) => {
          const visualPrestador = obtenerVisualPrestadorReciente(fila);

          return (
            <Column
              xs={12}
              md={6}
              xl={4}
              key={fila.prestadorCod || fila.prestadorNom}
            >
              <Card
                style={{ marginBottom: "7.5px", padding: "0px 14px" }}
                variant="outlined"
              >
                <Row
                  className="amarillo-sol"
                  style={{ textAlign: "start" }}
                  alignItems="center"
                  container
                >
                  <Column xs={8} sx={{ padding: "8px" }}>
                    <Row alignItems="center">
                      <div className="prestador-reciente-avatar">
                        {visualPrestador.tipo === "foto" ? (
                          <img
                            src={visualPrestador.imageSrc}
                            alt={visualPrestador.descripcion}
                            className="prestador-reciente-avatar-image"
                          />
                        ) : visualPrestador.tipo === "equipo" ? (
                          <PrecisionManufacturing className="prestador-reciente-avatar-icon" />
                        ) : (
                          <Person className="prestador-reciente-avatar-icon" />
                        )}
                      </div>
                      <Typography
                        sx={{
                          color: "#B50009",
                          display: "-webkit-box",
                          overflow: "hidden",
                          textOverflow: "ellipsis",
                          WebkitBoxOrient: "vertical",
                          WebkitLineClamp: 2,
                          lineHeight: 1.35,
                          minHeight: "2.7em",
                        }}
                        level="body-sm"
                      >{` ${fila.prestadorNom} - ${fila.especialidadNom}`}</Typography>
                    </Row>
                  </Column>
                  <Column xs={4} sx={{ padding: "8px", textAlign: "right" }}>
                    <Button
                      variant="soft"
                      color="danger"
                      size="sm"
                      onClick={() => {
                        handleClickReservarTurnoPrestador(fila.prestadorCod);
                      }}
                      startDecorator={<LibraryAdd />}
                    >
                      <Typography level="title-sm" sx={{ color: "white" }}>
                        {`RESERVAR TURNO`}
                      </Typography>
                    </Button>
                  </Column>
                </Row>
              </Card>
            </Column>
          );
        })}
      </Row>
    );
  };

  const renderTurnosLista = (seePreviusVersion) => {
    return (
      <IonGrid
        className="tabla"
        style={{
          margin: "10px",
          padding: "10px",
          borderRadius: "5px",
        }}
      >
        <IonIcon slot="start" md={calendar} ios={calendarOutline} />
        <Column className="" xs={12} marginBottom={1}>
          <Row>
            <Typography level="body-sm">Próximos turnos</Typography>
          </Row>
        </Column>
        {listadoTurnos.map((fila) => (
          <Card
            style={{ marginBottom: "7.5px", padding: "0px 14px" }}
            key={fila.codigo}
          >
            <Row
              className=""
              style={{ textAlign: "start" }}
              alignItems="center"
              container
            >
              <Column
                style={{ textAlign: "start" }}
                xs={6}
                md={8}
                lg={10}
                container
              >
                <Row alignItems="center" container>
                  <Column xs={12} md={6}>
                    <Typography level="title-sm" sx={{ color: "#B50009" }}>
                      {fila.prestadorNom === "EQUIPOS"
                        ? `${fila.estudioNom}`
                        : `${fila.prestadorNom + " - " + fila.especialidadNom}`}
                    </Typography>
                  </Column>
                  <Column xs={12} md={6}>
                    <Typography level="title-sm">
                      {`${obtenerNombreDia(
                        dayjs(fila.fecha).format("dddd"),
                      )} ${dayjs(fila.fecha).format("DD")} de ${dayjs(
                        fila.fecha,
                      ).format("MMMM, YYYY")} a las ${dayjs(fila.hora).format(
                        "HH:mm",
                      )}`}
                    </Typography>
                  </Column>
                </Row>
                <Row className="" alignItems="center" container>
                  <Column xs={12} md={6}>
                    <Typography level="body-sm">{`${fila.mutualNom}`}</Typography>
                  </Column>
                  <Column xs={12} md={6}>
                    <Typography level="body-sm">
                      {`Estado: ${
                        fila.asistio
                          ? "Asistido"
                          : fila.aCancelar
                            ? "Pendiente"
                            : "Cancelado"
                      }`}
                    </Typography>
                  </Column>
                </Row>
                <Row className="" alignItems="center" container>
                  <Column xs={12}>
                    <Typography level="body-sm">
                      {fila.prestadorNom === "EQUIPOS" &&
                      estudios.filter(
                        (estudio) => estudio.codigo === fila.estudio,
                      )[0]?.preparacion !== ""
                        ? convertToPlain(
                            estudios.filter(
                              (estudio) => estudio.codigo === fila.estudio,
                            )[0]?.preparacion,
                          )
                        : null}
                    </Typography>
                  </Column>
                </Row>
              </Column>
              <Column container xs={6} md={4} lg={2}>
                <Row container>
                  {(dayjs().format("YYYY-MM-DD") !==
                    dayjs(fila.fecha).format("YYYY-MM-DD") ||
                    (dayjs().format("YYYY-MM-DD") ===
                      dayjs(fila.fecha).format("YYYY-MM-DD") &&
                      dayjs(fila.hora).format("HH:mm") >
                        dayjs().format("HH:mm"))) &&
                  fila.aCancelar ? (
                    <Column xs={12} container>
                      <IonButton
                        shape="roud"
                        fill="clear"
                        onClick={() => handleClickComprobanteTurno(fila)}
                        style={{ margin: "0px" }}
                      >
                        <IonIcon
                          aria-label="Cancelar turno"
                          ios={printOutline}
                          md={print}
                          style={{ color: "#B50009" }}
                        />
                        <IonLabel style={{ color: "#B50009" }}>
                          Comprobante
                        </IonLabel>
                      </IonButton>
                      <IonButton
                        shape="roud"
                        fill="clear"
                        onClick={() => handleClickSeleccionarTurno(fila)}
                        style={{ margin: "0px" }}
                      >
                        <IonIcon
                          aria-label="Cancelar turno"
                          ios={closeOutline}
                          md={close}
                          style={{ color: "#B50009" }}
                        />
                        <IonLabel style={{ color: "#B50009" }}>
                          Cancelar
                        </IonLabel>
                      </IonButton>
                    </Column>
                  ) : (
                    <Column className="" xs={12} container>
                      <IonButton
                        shape="roud"
                        fill="clear"
                        onClick={() => handleClickComprobanteTurno(fila)}
                        style={{ margin: "0px" }}
                      >
                        <IonIcon
                          aria-label="Cancelar turno"
                          ios={printOutline}
                          md={print}
                          style={{ color: "#B50009" }}
                        />
                        <IonLabel style={{ color: "#B50009" }}>
                          Comprobante
                        </IonLabel>
                      </IonButton>

                      <IonButton
                        shape="roud"
                        fill="clear"
                        onClick={() =>
                          handleClickReservarTurnoPrestador(fila.prestadorCod)
                        }
                        style={{ margin: "0px" }}
                      >
                        <Typography level="title-sm" sx={{ color: "#B50009" }}>
                          {`Reservar turno`.toUpperCase()}
                        </Typography>
                        <LibraryAdd sx={{ color: "#B50009" }} />
                      </IonButton>
                    </Column>
                  )}
                </Row>
              </Column>
            </Row>
          </Card>
        ))}
      </IonGrid>
    );
  };

  return (
    <IonGrid>
      <IonRow>
        <IonCol sizeXs="12" sizeMd="6">
          <IonItem
            button
            lines="none"
            routerLink="/portal/Reservar turno"
            routerDirection="none"
            className="amarillo-sol"
          >
            <IonAvatar slot="start">
              <IonIcon
                ios={peopleCircleOutline}
                md={peopleCircle}
                size="large"
              />
            </IonAvatar>
            <Typography level="body-md">
              Reservar turno por Especialidad
            </Typography>
            <IonAvatar slot="end">
              <IonIcon
                ios={chevronForwardOutline}
                md={chevronForward}
                size="large"
              />
            </IonAvatar>
          </IonItem>
        </IonCol>

        <IonCol sizeXs="12" sizeMd="6">
          <IonItem
            button
            lines="none"
            routerLink="/portal/Turnos"
            routerDirection="none"
            className="amarillo-sol"
          >
            <IonAvatar slot="start">
              <IonIcon ios={calendarOutline} md={calendar} size="large" />
            </IonAvatar>
            <Typography level="body-md">Consultar mis turnos</Typography>
            <IonAvatar slot="end">
              <IonIcon
                ios={chevronForwardOutline}
                md={chevronForward}
                size="large"
              />
            </IonAvatar>
          </IonItem>
        </IonCol>
        <IonCol sizeXs="12" sizeMd="6">
          <IonItem
            button
            lines="none"
            routerLink="/portal/Estudios"
            routerDirection="none"
            className="amarillo-sol"
          >
            <IonAvatar slot="start">
              <IonIcon
                ios={fileTrayFullOutline}
                md={fileTrayFull}
                size="large"
              />
            </IonAvatar>
            <Typography level="body-md">Consultar mis estudios</Typography>
            <IonAvatar slot="end">
              <IonIcon
                ios={chevronForwardOutline}
                md={chevronForward}
                size="large"
              />
            </IonAvatar>
          </IonItem>
        </IonCol>
        <IonCol sizeXs="12" sizeMd="6">
          <IonItem
            button
            lines="none"
            routerLink="/portal/Reservar turno estudios"
            routerDirection="none"
            className="amarillo-sol"
          >
            <IonAvatar slot="start">
              <IonIcon
                ios={fileTrayFullOutline}
                md={fileTrayFull}
                size="large"
              />
            </IonAvatar>
            <Typography level="body-md">Reserva turno Estudios</Typography>
            <IonAvatar slot="end">
              <IonIcon
                ios={chevronForwardOutline}
                md={chevronForward}
                size="large"
              />
            </IonAvatar>
          </IonItem>
        </IonCol>
        <IonCol sizeXs="12" sizeMd="6">
          <IonItem
            button
            lines="none"
            onClick={() => handleClickRedirigir("Laboratorio")}
            className="amarillo-sol"
          >
            <IonAvatar slot="start">
              <IonIcon
                ios={flaskOutline}
                md={flask}
                size="large"
                style={{ color: "var(--ion-color-secondary-shade)" }}
              />
            </IonAvatar>
            <Typography
              level="body-md"
              sx={{
                color: "var(--ion-color-secondary-shade)",
                fontWeight: 600,
              }}
            >
              Resultados de laboratorio
            </Typography>
            <IonAvatar slot="end">
              <IonIcon
                ios={chevronForwardOutline}
                md={chevronForward}
                size="large"
                style={{ color: "var(--ion-color-secondary-shade)" }}
              />
            </IonAvatar>
          </IonItem>
        </IonCol>
      </IonRow>

      {listadoTurnos.length !== 0 && renderTurnosLista(true)}
      {prestadoresRecientes.length !== 0 && (
        <AccordionGroup>
          <Accordion defaultExpanded>
            <AccordionSummary>Prestadores recientes</AccordionSummary>
            <AccordionDetails>{renderPrestadoresRecientes()}</AccordionDetails>
          </Accordion>
        </AccordionGroup>
      )}

      <DialogoConfirmacion
        titulo="Cancelar turno"
        texto={`Ha decidido cancelar el turno con el/la profecional ${
          turnoSeleccionado.prestadorNom
        }, con especialidad en ${
          turnoSeleccionado.especialidadNom
        }, para el dia ${obtenerNombreDia(
          dayjs(turnoSeleccionado.fecha).format("dddd"),
        )} ${dayjs(turnoSeleccionado.fecha).format("DD")} de ${dayjs(
          turnoSeleccionado.fecha,
        ).format("MMMM, YYYY")} a las ${dayjs(turnoSeleccionado.hora).format(
          "HH:mm",
        )}, ¿Esta seguro/a de ello?`}
        open={abrirModalCancelarReserva}
        setOpen={setAbrirModalCancelarReserva}
        handleClickConfirmar={handleClickCancelarReserva}
        colorBotonNo="danger"
        colorBotonSi="success"
        textoBotonNo="No"
        textoBotonSi="Si, cancelo"
      />

      <ComprobanteTurno
        turno={turnoSeleccionado}
        abrir={abrirComprobanteTurno}
        togleAbrirCerrarComprobanteTurno={togleAbrirCerrarComprobanteTurno}
        paciente={paciente}
      />

      <CustomToast
        openToast={toast.open}
        onDidDismiss={(e) => mostrarNotificacion(false, "", "")}
        message={toast.mensaje}
        colorNotificacion={toast.tipo}
      />
      {cargandoAccion && <LoadingBackdrop visualizar={cargandoAccion} />}
    </IonGrid>
  );
};

export default MainPage;
